import { reelsSettings } from '../../settings/custom/reels'
import { Device } from '../../utils/Device'

export default class ItemsModel {
  constructor() {
    this._height = Device.isDesktop() ? reelsSettings.items.height : reelsSettings.items.height / 2
    this._width = Device.isDesktop() ? reelsSettings.items.width : reelsSettings.items.width / 2
    this._hiddenSymbol = Math.max(...reelsSettings.itemCount) + 2
  }

  get height() {
    return this._height
  }

  get width() {
    return this._width
  }

  get hiddenSymbol() {
    return this._hiddenSymbol
  }
}
